import { CLASS_GLYPH } from "../../core/classify";
import type { ReviewMove } from "../../core/review";

interface MoveListProps {
  moves: ReviewMove[];
  sel: number; // -1: başlangıç konumu
  onSelect: (ply: number) => void;
}

export function MoveList({ moves, sel, onSelect }: MoveListProps) {
  const rows: ReviewMove[][] = [];
  for (let i = 0; i < moves.length; i += 2) {
    rows.push(moves.slice(i, i + 2));
  }

  const cell = (m: ReviewMove | undefined, idx: number) => {
    if (!m) return <td key={idx} />;
    const cls = m.classification;
    const notable = cls === "blunder" || cls === "mistake" || cls === "inaccuracy" || cls === "best";
    return (
      <td
        key={m.ply}
        className={`mv ${sel === m.ply ? "sel" : ""} cls-${cls}`}
        onClick={() => onSelect(m.ply)}
        title={m.commentary ?? undefined}
      >
        {m.san}
        {notable && <span className="glyph">{CLASS_GLYPH[cls]}</span>}
      </td>
    );
  };

  return (
    <table className="movelist">
      <tbody>
        {rows.map((pair) => (
          <tr key={pair[0].moveNumber}>
            <td className="mvno">{pair[0].moveNumber}</td>
            {cell(pair[0], 0)}
            {cell(pair[1], 1)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
